/**
 * RelCoMentionsTab - Conversation chunks that mention both people.
 * Uses SNA search with both person hashes.
 */

import React from 'react';
import { Box, Typography, CircularProgress, Alert, Button } from '@mui/material';
import useRelationshipDetail from '../../hooks/useRelationshipDetail';
import EvidenceChunks from './EvidenceChunks';

function RelCoMentionsTab({ sourceNode, targetNode, entityId }) {
  const { coMentions, loading, error, retry } = useRelationshipDetail(
    entityId,
    sourceNode.id,
    targetNode.id
  );

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert
          severity="error"
          action={<Button color="inherit" size="small" onClick={retry}>Retry</Button>}
        >
          Failed to load co-mentions
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
        Co-Mentions ({coMentions.length})
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Conversation segments where both {sourceNode.label} and {targetNode.label} appear
      </Typography>

      {coMentions.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No co-mention evidence found
        </Typography>
      ) : (
        <EvidenceChunks chunks={coMentions} />
      )}
    </Box>
  );
}

export default RelCoMentionsTab;
